import { Public } from "../../../listsSettings/public";

export const allItems: string = `/_lists/${Public.Persons.InternalName}/_pages/all_items`;
export const newForm: string = `/_lists/${Public.Persons.InternalName}/_pages/new`;
export const dispForm: string = `/_lists/${Public.Persons.InternalName}/_pages/disp`;
export const editForm: string = `/_lists/${Public.Persons.InternalName}/_pages/edit`;
